import { z } from 'zod';
import { VISITOR_TRACKING_FIELD } from './publishedJourneyOptions.constants';

export const publishedJourneyOptionsSchema = z.object({
  [VISITOR_TRACKING_FIELD]: z.boolean().optional(), // for now this should be optional
});
